import { navigateTo } from "@util/routerService";
import router from 'next/router';
import { } from "react";
import { connect, useSelector } from 'react-redux';
import { BackArrowIcon, IconFrame } from '@element/icons';


function MiniHeader({ currentPage, storeMetaData }) {
  const currentPageStatus = useSelector((state: any) => state.currentPage);
  const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
  const { configData } = useSelector((state: any) => state.store.storeData);
  const store = useSelector((state: any) => state);
  const languageData: any = store.languageKeywords

  const onBackClick = () => {
    if (currentPageStatus == 'orderconfirmation' || currentPageStatus == "invoice" || currentPageStatus == "giftcardinvoice" || currentPageStatus == "membershipinvoice" || currentPageStatus == "packageinvoice" || currentPageStatus == "postcare") navigateTo('home')
    else router.back();
  }
  return (
    <>
      <div className="mainheaderblock mini-header-wrap">
        {Boolean(configData?.storeConfig?.basicConfig?.catalogue) && <div onClick={onBackClick} className="logo back-navigation">
          <IconFrame shape="circle" width={32} height={32} margin="0 0 0 5px"><BackArrowIcon /></IconFrame>
        </div>}
        <div className="heading">
          {currentPage == 'cart' ? `${languageData["Cart Details"] ? languageData["Cart Details"] : "Cart Details"}` :
            currentPage == 'checkout' ? `${languageData["Order Details"] ? languageData["Order Details"] : "Order Details"}` :
              currentPage == 'invoice' ? `${languageData["Order Invoice"] ? languageData["Order Invoice"] : "Order Invoice"}` :
                currentPage == 'membershipinvoice' ? `${languageData["Membership Invoice"] ? languageData["Membership Invoice"] : "Membership Invoice"}` :
                  currentPage == 'packageinvoice' ? `${languageData["Package Invoice"] ? languageData["Package Invoice"] : "Package Invoice"}` :
                    currentPage == 'giftcardinvoice' ? `${languageData["Gift Card Invoice"] ? languageData["Gift Card Invoice"] : "Gift Card Invoice"}` :
                      currentPage == 'advanceinvoice' ? `${languageData["Advance Invoice"] ? languageData["Advance Invoice"] : "Advance Invoice"}` :
                        currentPage == 'advancerefund' ? `${languageData["Advance Refund Invoice"] ? languageData["Advance Refund Invoice"] : "Advance Refund Invoice"}` :
                          currentPage == 'balanceinvoice' ? `${languageData["Balance Invoice"] ? languageData["Balance Invoice"] : "Balance Invoice"}` :
                            currentPage == 'appointment' ? `${languageData["Appointment Details"] ? languageData["Appointment Details"] : "Appointment Details"}` :
                              currentPage == 'purchase' ? `${languageData["Our Plans"] ? languageData["Our Plans"] : "Our Plans"}` :
                                currentPage == 'postcare' ? `${languageData["Post-Care Instructions"] ? languageData["Post-Care Instructions"] : "Post-Care Instructions"}` :
                                  currentPage == 'form' ? <>
                                  <div className="form-page-logo">
                                    <img
                                      src={storeMetaData ? storeMetaData?.logoPath : 'https://pcs-s3.s3.ap-south-1.amazonaws.com/2/logo/2022-09-16T10%3A06%3A23.774113_slider.png'}
                                      title="logo"
                                      alt="logo"
                                    />
                                  </div>
                                </> :
                                  ''}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state: any) => {
  return {
    storeData: state?.store?.storeData,
    storeMetaData: state?.store?.storeMetaData
  }
}
export default connect(mapStateToProps)(MiniHeader);

